import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="edit-category {{if this.expandedMenu 'expanded-menu'}}">
  <div class="edit-category-title-bar">
    <div class="edit-category-title">
      <h2>{{this.title}}</h2>
      {{#if this.model.id}}
        <BreadCrumbs
          @categories={{this.site.categoriesList}}
          @category={{this.model}}
          @noSubcategories={{this.model.noSubcategories}}
          @editingCategory={{true}}
          @editingCategoryTab={{this.selectedTab}}
        />
      {{/if}}
    </div>
    {{#if (and this.site.desktopView this.model.id)}}
      <DButton
        @action={{action "goBack"}}
        @label="category.back"
        @icon="caret-left"
        class="category-back"
      />
    {{/if}}
  </div>

  <div class="edit-category-nav">
    <ul class="nav nav-stacked">
      <EditCategoryTab
        @panels={{this.panels}}
        @selectedTab={{this.selectedTab}}
        @params={{this.parentParams}}
        @tab="general"
      />
      <EditCategoryTab
        @panels={{this.panels}}
        @selectedTab={{this.selectedTab}}
        @params={{this.parentParams}}
        @tab="security"
      />
      <EditCategoryTab
        @panels={{this.panels}}
        @selectedTab={{this.selectedTab}}
        @params={{this.parentParams}}
        @tab="settings"
      />
      <EditCategoryTab
        @panels={{this.panels}}
        @selectedTab={{this.selectedTab}}
        @params={{this.parentParams}}
        @tab="images"
      />
      <EditCategoryTab
        @panels={{this.panels}}
        @selectedTab={{this.selectedTab}}
        @params={{this.parentParams}}
        @tab="topic-template"
      />
      {{#if this.siteSettings.tagging_enabled}}
        <EditCategoryTab
          @panels={{this.panels}}
          @selectedTab={{this.selectedTab}}
          @params={{this.parentParams}}
          @tab="tags"
        />
      {{/if}}
    </ul>
  </div>

  <div class="edit-category-content">
    <h3>{{this.selectedTabTitle}}</h3>

    {{#each this.panels as |tab|}}
      {{component
        tab
        selectedTab=this.selectedTab
        category=this.model
        registerValidator=(action "registerValidator")
      }}
    {{/each}}
  </div>

  {{#if this.showDeleteReason}}
    <div class="edit-category-delete-warning">
      <p class="warning">{{html-safe this.model.cannot_delete_reason}}</p>
    </div>
  {{/if}}

  <div class="edit-category-footer">
    <DButton
      @disabled={{this.disabled}}
      @action={{action "saveCategory"}}
      @label={{this.saveLabel}}
      id="save-category"
      class="btn-primary"
    />

    {{#if this.model.can_delete}}
      <DButton
        @disabled={{this.deleteDisabled}}
        @action={{action "deleteCategory"}}
        @icon="far-trash-alt"
        @label="category.delete"
        class="btn-danger"
      />
    {{else if this.model.id}}
      <div class="disable-info">
        <DButton
          @disabled={{this.deleteDisabled}}
          @action={{action "toggleDeleteTooltip"}}
          @icon="question-circle"
          @label="category.delete"
          class="btn-default"
        />
      </div>
    {{/if}}
  </div>
</div>
*/
{
  "id": "5OTuONt+",
  "block": "[[[10,0],[15,0,[29,[\"edit-category \",[52,[30,0,[\"expandedMenu\"]],\"expanded-menu\"]]]],[12],[1,\"\\n  \"],[10,0],[14,0,\"edit-category-title-bar\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"edit-category-title\"],[12],[1,\"\\n      \"],[10,\"h2\"],[12],[1,[30,0,[\"title\"]]],[13],[1,\"\\n\"],[41,[30,0,[\"model\",\"id\"]],[[[1,\"        \"],[8,[39,1],null,[[\"@categories\",\"@category\",\"@noSubcategories\",\"@editingCategory\",\"@editingCategoryTab\"],[[30,0,[\"site\",\"categoriesList\"]],[30,0,[\"model\"]],[30,0,[\"model\",\"noSubcategories\"]],true,[30,0,[\"selectedTab\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"],[41,[28,[37,2],[[30,0,[\"site\",\"desktopView\"]],[30,0,[\"model\",\"id\"]]],null],[[[1,\"      \"],[8,[39,3],[[24,0,\"category-back\"]],[[\"@action\",\"@label\",\"@icon\"],[[28,[37,4],[[30,0],\"goBack\"],null],\"category.back\",\"caret-left\"]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"edit-category-nav\"],[12],[1,\"\\n    \"],[10,\"ul\"],[14,0,\"nav nav-stacked\"],[12],[1,\"\\n      \"],[8,[39,5],null,[[\"@panels\",\"@selectedTab\",\"@params\",\"@tab\"],[[30,0,[\"panels\"]],[30,0,[\"selectedTab\"]],[30,0,[\"parentParams\"]],\"general\"]],null],[1,\"\\n      \"],[8,[39,5],null,[[\"@panels\",\"@selectedTab\",\"@params\",\"@tab\"],[[30,0,[\"panels\"]],[30,0,[\"selectedTab\"]],[30,0,[\"parentParams\"]],\"security\"]],null],[1,\"\\n      \"],[8,[39,5],null,[[\"@panels\",\"@selectedTab\",\"@params\",\"@tab\"],[[30,0,[\"panels\"]],[30,0,[\"selectedTab\"]],[30,0,[\"parentParams\"]],\"settings\"]],null],[1,\"\\n      \"],[8,[39,5],null,[[\"@panels\",\"@selectedTab\",\"@params\",\"@tab\"],[[30,0,[\"panels\"]],[30,0,[\"selectedTab\"]],[30,0,[\"parentParams\"]],\"images\"]],null],[1,\"\\n      \"],[8,[39,5],null,[[\"@panels\",\"@selectedTab\",\"@params\",\"@tab\"],[[30,0,[\"panels\"]],[30,0,[\"selectedTab\"]],[30,0,[\"parentParams\"]],\"topic-template\"]],null],[1,\"\\n\"],[41,[30,0,[\"siteSettings\",\"tagging_enabled\"]],[[[1,\"        \"],[8,[39,5],null,[[\"@panels\",\"@selectedTab\",\"@params\",\"@tab\"],[[30,0,[\"panels\"]],[30,0,[\"selectedTab\"]],[30,0,[\"parentParams\"]],\"tags\"]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"edit-category-content\"],[12],[1,\"\\n    \"],[10,\"h3\"],[12],[1,[30,0,[\"selectedTabTitle\"]]],[13],[1,\"\\n\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"panels\"]]],null]],null],null,[[[1,\"      \"],[46,[30,1],null,[[\"selectedTab\",\"category\",\"registerValidator\"],[[30,0,[\"selectedTab\"]],[30,0,[\"model\"]],[28,[37,4],[[30,0],\"registerValidator\"],null]]],null],[1,\"\\n\"]],[1]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showDeleteReason\"]],[[[1,\"    \"],[10,0],[14,0,\"edit-category-delete-warning\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"warning\"],[12],[1,[28,[35,9],[[30,0,[\"model\",\"cannot_delete_reason\"]]],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,0],[14,0,\"edit-category-footer\"],[12],[1,\"\\n    \"],[8,[39,3],[[24,1,\"save-category\"],[24,0,\"btn-primary\"]],[[\"@disabled\",\"@action\",\"@label\"],[[30,0,[\"disabled\"]],[28,[37,4],[[30,0],\"saveCategory\"],null],[30,0,[\"saveLabel\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"model\",\"can_delete\"]],[[[1,\"      \"],[8,[39,3],[[24,0,\"btn-danger\"]],[[\"@disabled\",\"@action\",\"@icon\",\"@label\"],[[30,0,[\"deleteDisabled\"]],[28,[37,4],[[30,0],\"deleteCategory\"],null],\"far-trash-alt\",\"category.delete\"]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"model\",\"id\"]],[[[1,\"      \"],[10,0],[14,0,\"disable-info\"],[12],[1,\"\\n        \"],[8,[39,3],[[24,0,\"btn-default\"]],[[\"@disabled\",\"@action\",\"@icon\",\"@label\"],[[30,0,[\"deleteDisabled\"]],[28,[37,4],[[30,0],\"toggleDeleteTooltip\"],null],\"question-circle\",\"category.delete\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]],null]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"tab\"],false,[\"if\",\"bread-crumbs\",\"and\",\"d-button\",\"action\",\"edit-category-tab\",\"each\",\"-track-array\",\"component\",\"html-safe\"]]",
  "moduleName": "discourse/templates/edit-category-tabs.hbs",
  "isStrictMode": false
});